import api from "./api";

export const getAboutUs = async () => {
    try {
        const response = await api.get("/api/about-us");
        // User API might return directly from response interceptor or data field
        return response.data || response;
    } catch (error) {
        console.error("Error fetching about us:", error);
        throw error;
    }
};
